module.exports = __webpack_public_path__ + "img/body-background-textura04.5287b35b.svg";